import React, { Component } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import { Scrollbars } from "react-custom-scrollbars";

import Row from "./row.js";

class Rail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      dataLoad: [],
      description: "",
      page: 0,
      pageSize: 10,
      setHeight: false,
      loadMoreVisible: false,
      initial: true
    };

    this.loadMore = this.loadMore.bind(this);
    this.renderList = this.renderList.bind(this);
    this.updateFixedValues = this.updateFixedValues.bind(this);
  }

  componentDidMount() {
    this.renderList();

    window.addEventListener("resize", this.updateFixedValues);
    window.addEventListener("scroll", this.updateFixedValues);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateFixedValues);
    window.removeEventListener("scroll", this.updateFixedValues);
  }

  offset(el) {
    const rectangle = el.getBoundingClientRect();
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    return {
      top: rectangle.top + scrollTop,
      left: rectangle.left + scrollLeft,
      documentTop: rectangle.top,
      documentBottom: rectangle.bottom,
      documentLeft: rectangle.left,
      documentRight: rectangle.right
    };
  }

  updateFixedValues() {
    const list = document.getElementById("siderail-list");
    const aside = document.querySelector("#maincontent .aside");

    const wrapperList = list.querySelector(".siderail-list-outer");

    const article = document.querySelector(".chArticleDetails");
    const articleOffset = this.offset(article);

    const footer = document.getElementById("footer");
    const footerOffset = this.offset(footer);

    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    wrapperList.style.height = this.includeTwitterFeed ? "30vh" : "50vh";

    if (articleOffset.documentTop - 140 < 0 && viewportHeight - footerOffset.documentTop > 0 && footerOffset.documentBottom > 0) {
      wrapperList.style.minHeight = this.includeTwitterFeed ? "314px" : "30vh";
    } else {
      list.style.width = aside.offsetWidth + "px";
    }
  }

  loadMore() {
    this.setState(
      {
        data: this.state.data.concat(this.state.dataLoad),
        page: this.state.page + 1
      },
      this.renderList
    );
  }

  renderList() {
    let paramsObj = {
      pageSize: this.state.pageSize,
      page: this.state.page
    };

    return axios
      .get(this.props.api.siderailList, {
        params: paramsObj
      })
      .then(results => {
        if (results.data.Results.length > 0) {
          if (this.state.initial) {
            this.setState({ data: results.data.Results }, this.updateFixedValues);
            this.setState({ page: this.state.page + 1, initial: false }, this.renderList);
          } else {
            this.setState({
              dataLoad: results.data.Results,
              loadMoreVisible: true
            });
          }
        } else {
          this.setState({
            loadMoreVisible: false
          });
        }
      })
      .catch(err => {
        throw err;
      });
  }

  render() {
    this.includeTwitterFeed =
      document.getElementById("siderail-articles").getAttribute("data-include-twitter-feed") === "true";

    this.twitterFeed = document.getElementById("siderail-articles").getAttribute("data-twitter-feed");

    return (
      <div className="siderail-list">
        <div className="tri-arrow"></div>
        <Scrollbars className="siderail-list-outer" style={{ height: this.includeTwitterFeed ? "40vh" : "50vh" }}>
          <div className="siderail-list-inner">
            {this.state.data.map(row => (
              <Row
                key={row.ItemID}
                title={row.Title}
                pageURL={row.PageURL}
                current={row.CurrentArticle}
                prefix={row.TitlePrefix}
              />
            ))}
          </div>
          <span
            id="load"
            className={this.state.loadMoreVisible ? "showLoad" : ""}
            onClick={this.loadMore}>
            Load More Posts
          </span>
        </Scrollbars>

        {this.includeTwitterFeed && (
          <div className="twitter-box">
            <div className="whiteBox3">
              <a className="twitter-timeline" href={"https://twitter.com/" + this.twitterFeed} data-height="400">Tweets by {this.twitterFeed}</a>
            </div>
          </div>
        )
        }
      </div>
    );
  }
}

Rail.propTypes = {
  api: PropTypes.object
};

export default Rail;
